import React from 'react';
import { VelocityScroll } from './ui/scroll-based-velocity';

const AntixVelocityScroll = () => {
  return (
    <div className="py-14 bg-white overflow-hidden">
      <VelocityScroll
        text="Gigs. Festivals. Friends. Memories. Together. "
        default_velocity={2}
        className="text-6xl md:text-8xl font-bold text-black/10 font-['Space_Grotesk']"
      />
    </div>
  );
};

export default AntixVelocityScroll;